import React, { Component } from "react";

class SelectBox extends Component {
  render() {
    const { changeHandler, defaultText, label, name, options, selectedValue } =
      this.props;

    return (
      <label htmlFor={`sel_${name}`}>
        <strong>{label}</strong>
        <select name={name} onChange={changeHandler} value={selectedValue}>
          <option value="any" defaultValue>
            {" "}
            {defaultText}{" "}
          </option>
          {options &&
            options
              .sort((a, b) => (a.text > b.text ? 1 : -1))
              .map((option, index) => (
                <option key={index} value={option.text}>
                  {option.text}
                </option>
              ))}
        </select>
      </label>
    );
  }
}

export default SelectBox;



// WEBPACK FOOTER //
// ./src/components/selectBox.js